import './coming-soon.scss';

import React from 'react';
import { Page } from '../page/Page';

/**
 * A simple element to track what features are not implemented
 */
export const ComingSoon = () => <Page type="coming-soon"></Page>;
